var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 9,
    viewBox: "0 0 100 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-icon-green",
    transform: "translate(0 -0.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M99.6,5.492c-.869,0-98.686.006-99.6.016",
    transform: "translate(0 -0.976)",
    fill: "none",
    stroke: "#01ae8f",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M211.778,4.012l-8.4-3.426A1,1,0,0,0,202,1.512v7a1,1,0,0,0,1.392.92l8.4-3.574a1,1,0,0,0-.014-1.846Z",
    transform: "translate(-112.4 0)",
    fill: "#01ae8f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconGreen);
export default __webpack_public_path__ + "static/media/arrow-icon-green.a4a1a8aca5fb3c4f4ba7b9093cfbdc03.svg";
export { ForwardRef as ReactComponent };